import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { back, forward, go, goReload } from '../actions/router.action';

@Injectable()
export class RouterEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private location = inject(Location);

  public navigate$ = createEffect(() => this.actions$.pipe(
    ofType(go),
    tap(({ path, query: queryParams, extras }) => {
      this.router.navigate(path, { queryParams, ...extras });
    }),
  ), { dispatch: false });

  public navigateReload$ = createEffect(() => this.actions$.pipe(
    ofType(goReload),
    tap(({ path, query: queryParams, extras }) => {
      this.router.navigate(path, { queryParams, ...extras });
      window.location.reload();
    }),
  ), { dispatch: false });


  public navigateBack$ = createEffect(() => this.actions$
    .pipe(
      ofType(back),
      tap(() => this.location.back())
    ), { dispatch: false });


  public navigateForward$ = createEffect(() => this.actions$
    .pipe(
      ofType(forward),
      tap(() => this.location.forward())
    ), { dispatch: false });
}
